<div class="container-fluid vh-100">
  <div class="row h-100">
    <div class="col-md-6 d-flex align-items-center justify-content-center login-left">
      <div class="text-center">
        <div class="login-tittle" [innerHTML]="login_title"></div>
        <img class="login-img mb-4" *ngIf="logoUrl" [src]="logoUrl" alt="Logo" style="max-width: 400px;">
      </div>
    </div>
    <div class="col-md-6 d-flex align-items-center justify-content-center login-right position-relative">
        <!-- 添加語言切換器在右上角 -->
      <div *ngIf="multilanguage" class="language-switcher-container">
        <app-language-switcher></app-language-switcher>
      </div>
      <!-- Standard Login Form -->
      <div class="login-form w-75" *ngIf="!showMfaVerification && !showMfaSetup">
        <h2 class="mb-4 text-dark">{{ title_text | translate }}</h2>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <label for="email" class="form-label">{{ id_text | translate }}</label>
            <input type="email" class="form-control" id="username" formControlName="username" >
          </div>
          <div class="mb-3">
            <label for="password" class="form-label">{{ pw_text | translate }}</label>
            <input type="password" class="form-control" formControlName="password" id="password" >
          </div>
          <div class="d-flex justify-content-between align-items-center mb-4">
            <button type="submit" class="btn btn-primary login" [disabled]="loginForm.invalid || isSubmitting">
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ login_text | translate }}
            </button>

            <!-- <a class="text-secondary">{{ forget_text | translate }}</a> -->
          </div>
        </form>
        <p class="text-center text-muted mt-5 ">Copyright © {{copyright}} <span *ngIf="version"> | Version:{{version}}</span> </p>
      </div>

      <!-- MFA Verification -->
      <div class="mfa-verification-form w-75" *ngIf="showMfaVerification">
        <app-mfa-verify
          [username]="currentLoginResult?.username"
          (verified)="onMfaVerified($event)"
          (cancel)="onMfaCancelled()">
        </app-mfa-verify>
      </div>

      <!-- MFA Setup -->
      <div class="mfa-setup-form w-75" *ngIf="showMfaSetup">
        <app-mfa-setup
          (setupCompleted)="onMfaSetupCompleted($event)"
          (setupCancelled)="onMfaSetupCancelled()">
        </app-mfa-setup>
      </div>
    </div>
  </div>
</div>
